import { gql } from '@apollo/client';

export const LIST_KB_DOCUMENTS_QUERY = gql`
  query ListKbDocuments($input: ListKbDocumentsInput) {
    listKbDocuments(input: $input) {
      statusCode
      message
      documents {
        s3Key
        fileName
        size
        lastModified
      }
    }
  }
`;
